module.exports = __webpack_public_path__ + "img/cn_pocket-22.2a578ed.jpg";